import { mergeWeeklyBadgeBuffs, type WeeklyBadgeGrant } from "@/rank/leaderboard-types";

export function weeklyRankBuffHint(grants: WeeklyBadgeGrant[]): string {
  if (grants.length === 0) return "";
  const buff = mergeWeeklyBadgeBuffs(grants);
  const parts: string[] = [];
  if (buff.attack) parts.push(`ATK +${buff.attack}`);
  if (buff.defense) parts.push(`DEF +${buff.defense}`);
  if (buff.dodge) parts.push(`หลบ +${buff.dodge}`);
  if (buff.hit) parts.push(`แม่น +${buff.hit}`);
  if (buff.critChance) parts.push(`คริ +${(buff.critChance * 100).toFixed(1)}%`);
  if (buff.hpRegenPerSec) parts.push(`ฟื้น +${buff.hpRegenPerSec}/วิ`);
  if (parts.length === 0) return "ป้ายแรงค์ (สัปดาห์นี้)";
  return `ป้ายแรงค์: ${parts.join(" · ")}`;
}
